import AutocompleteSearchPerson from "./AutocompleteSearchPerson";

export default AutocompleteSearchPerson;
